import React, { useEffect, useState } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import Checkbox from '@material-ui/core/Checkbox';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

// Action
import * as FleetActions from 'store/ducks/fleet/actions';
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { CarInterface } from 'store/ducks/fleet/types';
import { ApplicationState } from 'store';

// Helpers
import { useDebouncedSearch } from 'helpers/debounceHook';
import { promiseDispatch } from 'store/utils/promiseAction';
import {
  setCurrentSearchTerm,
} from 'helpers/tableFilters';

// Components
import { SearchAsyncComponent } from 'components/SearchAsyncComponent';

// Styles
import useStyles from './carsFilter.styles';

const storegeLimit =
  JSON.parse(window.localStorage.getItem('persist:root') as string)
    ?.localLimit || '10';
const { localLimit } = JSON.parse(storegeLimit) || 10;

async function searchCars(filter: string) {
  let searchObj = null;

  if (/^\d+$/.test(filter)) {
    searchObj = {
      filtering: true,
      body: {
        prefix: `%${filter}%`,
        _limit: localLimit,
      },
    };
  } else {
    searchObj = {
      filtering: true,
      body: {
        name: `%${filter}%`,
        _limit: localLimit,
      },
    };
  }

  return promiseDispatch(FleetActions.filterMonitoringCarsRequest(searchObj));
}

const useSearchCars = () => useDebouncedSearch(searchCars);

const CarsFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [
    autoCompleteText,
    setAutoCompleteText,
    searchResults,
  ] = useSearchCars();

  const carsData = useSelector(
    (state: ApplicationState) => state.fleet.filterCarsList || [],
  );

  const [carsList, setCarsList] = useState<any[]>([]);

  const filteredCars = useSelector(
    (state: ApplicationState) => state.reports.selectedCars,
  );
  useEffect(() => {
    dispatch(
      FleetActions.filterMonitoringCarsRequest({
        body: { _limit: localLimit },
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setCarsList(carsData);
  }, [carsData]);

  const handleCheck = (car: CarInterface) => {
    const updated = [...filteredCars];
    const index = filteredCars.findIndex((e) => e.id === car.id);

    if (index === -1) updated.push({ license: car.license, id: car.id });
    else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedCars({
        selectedCars: updated,
      }),
    );
  };

  return (
    <Box>
      <SearchAsyncComponent
        placeholder='Digite o prefixo'
        loading={searchResults.loading}
        classes={{
          root: classes.root,
        }}
        inputSize='small'
        onChange={(text: string) => {
          setCurrentSearchTerm(text);
          setAutoCompleteText(text);
          if (!text) {
            dispatch(
              FleetActions.listCarsRequest({
                filtering: true,
              }),
            );
          }
        }}
        value={autoCompleteText}
      />
      <Box marginTop={1}>
        <List dense>
          {Array.isArray(carsList) &&
            carsList.map((item: CarInterface) => (
              <ListItem key={item.id} button>
                <ListItemText
                  id={item.id}
                  onClick={() => handleCheck(item)}
                  classes={{ root: classes.itemText }}
                  primary={`PLACA: ${item.license} | PREFIXO: ${item.prefix}`}
                />
                <ListItemSecondaryAction>
                  <Checkbox
                    edge='end'
                    color='primary'
                    onChange={() => handleCheck(item)}
                    inputProps={{ 'aria-labelledby': item.id }}
                    checked={!!filteredCars.find((e) => e.id === item.id)}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
};

export { CarsFilter };
export default CarsFilter;
